import React, { useContext, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { UserContext } from "../../contexts/UserContext";
import { Button as HyperButton } from "../../Theme/Hyper";

const PENALTIES_BY_PLAYER_ID = gql`
  query PenaltiesByPlayerID($player_ID: String) {
    penaltiesByPlayerID(player_ID: $player_ID) {
      event_ID
      y
      z
      outcome
    }
  }
`;
const Button = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #181d25;
  min-height: 50px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  padding: 0.2em;
  cursor: pointer;
  :hover {
    background-color: #db0a41;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: cetner;
`;
const Caption = styled.div`
  display: flex;
  justify-content: center;
  font-size: 0.8em;
  text-align: center;
`;
const Tabs = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const TabButton = styled(HyperButton)`
  margin: 0.5em;
  background-color: ${(props) => (props.selected ? "#0adb93" : "")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
`;

const TAB_MAIN = 0;
const TAB_CARDS = 1;
export default function EFLPlayer({
  player,
  previewGraphic,
  game,
  sky,
  countries,
  period,
  selectedSubPlayer,
  allOptaEvents,
}) {
  const { user, signOut, teams: user_teams } = useContext(UserContext);
  const [tab, setTab] = useState(TAB_MAIN);
  const [getPenalties] = useLazyQuery(PENALTIES_BY_PLAYER_ID, {
    fetchPolicy: "network-first",
  });

  return (
    <>
      <Tabs>
        <TabButton selected={tab === TAB_MAIN} onClick={() => setTab(TAB_MAIN)}>
          MAIN
        </TabButton>
        <TabButton
          selected={tab === TAB_CARDS}
          onClick={() => setTab(TAB_CARDS)}
        >
          CARDS
        </TabButton>
      </Tabs>
      {tab === TAB_CARDS && (
        <>
          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 1,
                team: player?.team,

                countries: countries,
                game,
                clock: true,
              });
            }}
          >
            Yellow Card
          </Button>

          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 2,
                team: player?.team,
                game,
                countries: countries,
                clock: true,
              });
            }}
          >
            2nd Yellow Card
          </Button>

          <Button
            onClick={() => {
              previewGraphic("Card", {
                player,
                cardType: 3,
                team: player?.team,
                game,
                countries: countries,
                clock: true,
              });
            }}
          >
            Red Card
          </Button>
          {(user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") && (
              <Button
                onClick={() => {
                  previewGraphic("Card", {
                    player,
                    cardType: 1,
                    team: player?.team,
                    sky: sky,
                    countries: countries,
                    game,
                    clock: false,
                  });
                }}
              >
                L3 Yellow Card
              </Button>
            )}
          {(user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") && (
              <Button
                onClick={() => {
                  previewGraphic("Card", {
                    player,
                    cardType: 2,
                    team: player?.team,
                    sky: sky,
                    countries: countries,
                    game,
                    clock: false,
                  });
                }}
              >
                L3 2nd Yellow Card
              </Button>
            )}
          {(user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") && (
              <Button
                onClick={() => {
                  previewGraphic("Card", {
                    player,
                    cardType: 3,
                    team: player?.team,
                    sky: sky,
                    countries: countries,
                    game,
                    clock: false,
                  });
                }}
              >
                L3 Red Card
              </Button>
            )}
        </>
      )}
      {tab === TAB_MAIN && (
        <>
          <Button
            onClick={() => {
              previewGraphic("Name", {
                player: player,
                subtext: player?.team?.name,
                team: player?.team,
                sky: sky,
                countries: countries,
                game,
              });
            }}
          >
            Name
          </Button>
          {user_teams?.findIndex((t) => t.name === "WSL_TEAM") === -1 &&
            user?.username !== "sky" &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    customStatType: "CB",
                  });
                }}
              >
                Player stats
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky" ||
              user?.username === "PremierSports") &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    type: "Attack",
                  });
                }}
              >
                Player stats Attack
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky" ||
              user?.username === "PremierSports") &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    type: "Defence",
                  });
                }}
              >
                Player stats Defence
              </Button>
            )}

          {/* Full frame stats are only available between halves, not in play. */}
          {user_teams?.findIndex((t) => t.name === "WSL_TEAM") === -1 &&
            user?.username !== "sky" &&
            game?.dfb_ID === null &&
            !period?.kick_off &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    full_frame: true,
                  });
                }}
              >
                FF Player stats
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") &&
            !period?.kick_off &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    full_frame: true,
                    type: "Attack",
                  });
                }}
              >
                FF Player Stats Attack
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") &&
            !period?.kick_off &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerStats", {
                    player,
                    team: player?.team,
                    game,
                    full_frame: true,
                    type: "Defence",
                  });
                }}
              >
                FF Player Stats Defence
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            !player.title &&
            game?.dfb_ID === null && (
              <Button
                onClick={() => {
                  previewGraphic("TouchMap", {
                    player,
                    team: player?.team,
                    opta_events: allOptaEvents,
                    game,
                  });
                }}
              >
                Touch Map
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            !player.title && (
              <Button
                onClick={() => {
                  previewGraphic("PlayerHeatmap", {
                    player,
                    team: player?.team,
                    opta_events: allOptaEvents,
                    game,
                  });
                }}
              >
                Heat Map
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            !player.title &&
            game?.dfb_ID === null && (
              <Button
                onClick={() => {
                  previewGraphic("PassMap", {
                    player,
                    team: player?.team,
                    opta_events: allOptaEvents,
                    game,
                  });
                }}
              >
                Pass Map
              </Button>
            )}
          {game?.competition?.opta_ID !== "5ixq8vcn9w12n74fuj6oj9lj7" &&
            !player.title &&
            game?.dfb_ID === null && (
              <Button
                onClick={() => {
                  previewGraphic("ShotMap", {
                    player,
                    team: player?.team,
                    opta_events: allOptaEvents,
                    game,
                  });
                }}
              >
                Shot Map
              </Button>
            )}
          {/*!player.title && (
          <Button
            onClick={async () => {
              console.log("Penalty History player_ID sent:", player?._id, {
                first_name: player?.first_name ?? player?.opta_first_name,
                last_name: player?.last_name ?? player?.opta_last_name,
                opta_ID: player?.opta_ID,
                dfb_ID: player?.dfb_ID,
              });
              let { data } = await getPenalties({
                variables: { player_ID: player?._id },
              });
              console.log("Penalty History response:", data);
              let penalties = [...(data?.penaltiesByPlayerID || [])]
                .sort((a, b) => b.event_ID - a.event_ID)
                .slice(0, 5);
              previewGraphic("PenaltyHistory", {
                player,
                team: player?.team,
                game,
                penalties,
              });
            }}
          >
            Penalty History
          </Button>
        )*/}

          {!player.title && (
            <Button
              onClick={() => {
                previewGraphic("POTM", {
                  player,
                  team: player?.team,
                  game,
                });
              }}
            >
              POTM
            </Button>
          )}

          {player.stories &&
            player.stories.map((stat) => {
              return (
                <Button
                  onClick={() => {
                    previewGraphic("Name", {
                      team: player?.team,
                      player: player,
                      sky: sky,
                      subtext: stat.story,
                      countries: countries,
                      shirt_number:
                        player.shirt_number ?? player.opta_shirt_number ?? "",
                      game,
                    });
                  }}
                >
                  <Caption>{stat.story}</Caption>
                </Button>
              );
            })}
          {selectedSubPlayer && (
            <Button
              onClick={() => {
                previewGraphic("Substitution", {
                  players: [selectedSubPlayer, player],
                  team: player?.team,
                  game: game,
                  clock: true,
                });
              }}
            >
              Substitution{" "}
              {user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky"
                ? " U3"
                : ""}
            </Button>
          )}
          {selectedSubPlayer &&
            (user_teams?.findIndex((t) => t.name === "WSL_TEAM") > -1 ||
              user?.username === "sky") && (
              <Button
                onClick={() => {
                  previewGraphic("Substitution", {
                    players: [selectedSubPlayer, player],
                    team: player?.team,
                    game: game,
                    clock: false,
                  });
                }}
              >
                Substitution L3
              </Button>
            )}
        </>
      )}
    </>
  );
}
